import { NgModule, Injectable } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatInputModule } from '@angular/material/input';

import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule, MatPaginatorIntl } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';

import { MatSliderModule, } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';

import { MatNativeDateModule, DateAdapter, NativeDateAdapter } from '@angular/material/core';

import { getPaginatorIntl } from './shared/utils/pagination';
import { MatSelectSearchModule } from './shared/components/mat-select-search/mat-select-search.module';
import { MatDialogModule } from '@angular/material/dialog';


@Injectable({
  providedIn: 'root'
})
export class DateFormat extends NativeDateAdapter {
  useUtcForDisplay = true;
  parse(value: any): Date | null {
    if ((typeof value === 'string') && (value.indexOf('/') > -1)) {
      const str = value.split('/');
      const year = Number(str[2]);
      const month = Number(str[1]) - 1;
      const date = Number(str[0]);
      return new Date(year, month, date);
    }
    const timestamp = typeof value === 'number' ? value : Date.parse(value);
    return isNaN(timestamp) ? null : new Date(timestamp);
  }
}

@NgModule({
  exports: [
    /*
    A11yModule,
    CdkStepperModule,
    CdkTableModule,
    CdkTreeModule,
    DragDropModule,
    MatAutocompleteModule,
    
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    
    MatChipsModule,
    
    MatGridListModule,
    MatIconModule,
    //MatBadgeModule,
    //MatTooltipModule,
    MatDividerModule,
    */
    MatDialogModule,
    MatMenuModule, //trocar para dropdown
    MatStepperModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatCheckboxModule,
    MatInputModule,
    MatSnackBarModule,
    MatRadioModule,
    MatSelectModule,
    MatTableModule,
    MatPaginatorModule,
    MatSelectSearchModule,
    MatSlideToggleModule,
    MatNativeDateModule,
    MatSliderModule,
    /*
    MatTabsModule,
    MatListModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    
    MatRippleModule,
    
    MatSidenavModule,
    ,
    
    MatSortModule,
    
    MatToolbarModule,
    
    MatTreeModule,
    PortalModule,
    ScrollingModule,
    
    */
  ],
  providers: [
    { provide: DateAdapter, useClass: DateFormat },
    { provide: MatPaginatorIntl, useValue: getPaginatorIntl() }
  ],
})

export class MaterialModule {
  constructor(private dateAdapter: DateAdapter<Date>) {
    dateAdapter.setLocale('pt-BR'); // DD/MM/YYYY
  }
}